import EventEmitter from "eventemitter3";

import { useRef } from "react";
import useEffectOnce from "react-use/lib/useEffectOnce";

const ee = new EventEmitter();

export function useListenEvent<Event extends string, Data>(
  eventName: Event,
  callback?: (data: Data) => void
) {
  const callbackRef = useRef(callback);

  callbackRef.current = callback;

  useEffectOnce(() => {
    if (!callbackRef.current) return;

    const cb = (data: Data) => {
      callbackRef.current?.(data);
    };

    ee.addListener(eventName, cb);

    return () => {
      ee.removeListener(eventName, cb);
    };
  });
}

export function dispatchEvent<Event extends string, Data>(event: Event, data: Data) {
  return requestAnimationFrame(() => ee.emit(event, data));
}
